export const setCookieByHoursChatbot = (cname, cvalue, exhours = 24) => {
  const dateChatbot = new Date();
  dateChatbot.setTime(dateChatbot.getTime() + (exhours * 60 * 60 * 1000));
  const expires = 'expires=' + dateChatbot.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const setCookieByDaysChatbot = (cname, cvalue, exdays = 365) => {
  const dateChatbot = new Date();
  dateChatbot.setTime(dateChatbot.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + dateChatbot.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookieChatbot = (cname) => {
  const name = cname + '=';
  const caChabot = document.cookie.split(';');

  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < caChabot.length; i++) {
    let cChabot = caChabot[i];
    // tslint:disable-next-line:triple-equals
    while (cChabot.charAt(0) == ' ') {
      cChabot = cChabot.substring(1);
    }
    // tslint:disable-next-line:triple-equals
    if (cChabot.indexOf(name) == 0) {
      return cChabot.substring(name.length, cChabot.length);
    }
  }
  return '';
};

export const deleteAllCookiesChatbot = () => {
  // tslint:disable-next-line:prefer-for-of
  document.cookie
    .split(';')
    .forEach((cChatbot) => {
      document.cookie = cChatbot.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });

};
